import React, { useEffect } from 'react';
import DocumentTitle from 'react-document-title';
import { useTranslation } from 'react-i18next';
import TopNavBar from 'containers/nav/TopNavBar';
import SubNavBar from 'containers/nav/SubNavBar';
import AdministrationSubNav from 'components/administration/AdministrationSubNav';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IoTriangle, IoSquare, IoEllipseSharp } from 'react-icons/io5';
import GroupList from './GroupList';
import SaveModal from './SaveModal';
import useOrganizationSearch from './useOrganizationSearch';

const AdministrationOrganizationPage = ({ history }) => {
  const { t } = useTranslation();
  const { searchTerm, setSearchTerm, submitSearch, clearSearch, activeQuery, isSearching } = useOrganizationSearch();

  useEffect(() => {
    const q = new URLSearchParams(window.location.search).get('q');
    if (q) {
      setSearchTerm(q);
      submitSearch(q);
    }
  }, []);

  const handleSubmitSearch = (term) => {
    submitSearch(term);
    const params = new URLSearchParams(window.location.search);
    if (term.trim()) {
      params.set('q', term.trim());
    } else {
      params.delete('q');
    }
    history.replace({ search: params.toString() });
  };

  const handleClearSearch = () => {
    clearSearch();
    const params = new URLSearchParams(window.location.search);
    params.delete('q');
    history.replace({ search: params.toString() });
  };

  return (
    <DocumentTitle title={t('administration.pageTitle')}>
      <div style={{ minWidth: '1200px' }}>
        <TopNavBar />
        <SubNavBar />
        <AdministrationSubNav />
        <div className="row content">
          <div className="column">
            <div className="row">
              <div className="o-group-legend" style={{position: 'relative'}}>
                <a className='faq'href={window.ADMINISTRATION_YOUR_ORGANIZATION_FAQ_URL} target='_blank' rel="noreferrer" style={{position: 'absolute', right: 0, top: '8px'}}>
                  <i className='fa fa-question-circle' style={{ fontSize: 20, color: '#31ccff' }}></i>
                </a>
                <ul style={{display: 'flex', flexDirection: 'column', padding: '0'}}>
                  <li style={{display: 'flex', alignItems: 'center', paddingLeft: '0px'}}>
                    <IoSquare style={{marginRight: '2px', color: 'purple'}} />
                    <span style={{fontSize: '14px'}}>{t('administration.organization.groupLabel')}</span>
                  </li>
                  <li style={{display: 'flex', alignItems: 'center', paddingLeft: '16px'}}>
                    <IoTriangle style={{marginRight: '2px', color: 'green'}} />
                    <span style={{fontSize: '14px'}}>{t('administration.organization.subgroupLabel')}</span>
                  </li>
                  <li style={{display: 'flex', alignItems: 'center', paddingLeft: '32px'}}>
                    <IoEllipseSharp style={{marginRight: '2px', color: 'blue'}} />
                    <span style={{fontSize: '14px'}}>{t('administration.organization.cohortLabel')}</span>
                  </li>
                </ul>
              </div>
              <div className="o-group-search">
                <div className="o-group-search__input-wrap">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmitSearch(searchTerm)}
                    placeholder={t('administration.organization.searchPlaceholder')}
                  />
                  {searchTerm && (
                    <button className="o-group-search__clear" onClick={handleClearSearch} title="Clear search">
                      &times;
                    </button>
                  )}
                </div>
                <button
                  className="o-sp-button o-sp-button--update o-sp-button--primary"
                  onClick={() => handleSubmitSearch(searchTerm)}
                  disabled={isSearching}
                  style={{ minWidth: 90 }}
                >
                  {t('actions.search')}
                </button>
              </div>
              <div className="o-group-list">
                <GroupList />
              </div>
              <SaveModal />
            </div>
          </div>
        </div>
      </div>
    </DocumentTitle>
  );
}

AdministrationOrganizationPage.propTypes = {
  history: PropTypes.object.isRequired,
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = () => {
  return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationOrganizationPage);
